<template>
  <div>
    <Header />
    <div class="shadow">
      <h4>Your payments</h4>
      <PaymentDataGrid v-if="loaded" :paymentArray="mixedPayments" />
      <p v-if="!loaded">Loading...</p>
      <svg
        v-if="!loaded"
        class="spinner"
        width="65px"
        height="65px"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          class="path"
          fill="none"
          stroke-width="6"
          stroke-linecap="round"
          cx="33"
          cy="33"
          r="30"
        />
      </svg>
    </div>
  </div>
</template>

<script>
const Header = () => import("@/components/Header");
const PaymentDataGrid = () => import("@/components/PaymentDataGrid");

export default {
  components: {
    Header,
    PaymentDataGrid,
  },
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    mixedPayments() {
      let payments = this.$store.getters.user.panPayments;
      return payments.sort((a, b) => {
        return this.toDate(b.date) - this.toDate(a.date);
      });
    },
  },
  methods: {
    toDate(dateStr) {
      var parts = dateStr.split("/");
      return new Date(parts[2], parts[1] - 1, parts[0]);
    },
  },
  async created() {
    this.loaded = true;
  },
};
</script>

<style scoped>
.shadow {
  -webkit-box-shadow: 3px 2px 14px -1px rgba(204, 204, 204, 1);
  -moz-box-shadow: 3px 2px 14px -1px rgba(204, 204, 204, 1);
  box-shadow: 3px 2px 14px -1px rgba(204, 204, 204, 1);
  background-color: white;
  border-bottom: 2px solid #41b3a3;
  margin: 5px;
  padding: 10px;
}

.shadow h4 {
  text-align: left;
}

.spinner {
  animation: rotator 1.4s linear infinite;
}

@keyframes rotator {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(270deg);
  }
}

.path {
  stroke-dasharray: 187;
  stroke-dashoffset: 0;
  transform-origin: center;
  animation: dash 1.4s ease-in-out infinite,
    colors (1.4s * 4) ease-in-out infinite;
}

@keyframes colors {
  0% {
    stroke: #41b3a3;
  }
  25% {
    stroke: #c38d9e;
  }
  50% {
    stroke: #41b3a3;
  }
  75% {
    stroke: #85cdca;
  }
  100% {
    stroke: #41b3a3;
  }
}

@keyframes dash {
  0% {
    stroke-dashoffset: 187;
  }
  50% {
    stroke-dashoffset: 187/4;
    transform: rotate(135deg);
  }
  100% {
    stroke-dashoffset: 187;
    transform: rotate(450deg);
  }
}
</style>